/* eslint-disable no-bitwise */

export interface RGBHolder {
    r: number;
    g: number;
    b: number;
}

export interface RGBAHolder extends RGBHolder {
    a: number;
}

export const hexToRgb = (hexInput: string): RGBHolder => {
    const hex = Array.from(hexInput)[0] === '#' ? hexInput : `#${hexInput}`;

    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = `0x${c.join('')}`;

        return {
            r: (c >> 16) & 255,
            g: (c >> 8) & 255,
            b: c & 255,
        };
    }
    throw new Error(`Invalid HEX string: ${hexInput}`);
};

export const rgbaStringToObject = (rgbaStringInput: string): RGBAHolder => {
    const rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*((\d+)?(?:\.\d+)?))?\)$/;

    if (rgbaRegex.test(rgbaStringInput)) {
        const rgbArray = rgbaStringInput
            .substring(5, rgbaStringInput.length - 1)
            .replace(/ /g, '')
            .split(',');

        return {
            r: parseInt(rgbArray[0], 10),
            g: parseInt(rgbArray[1], 10),
            b: parseInt(rgbArray[2], 10),
            a: parseFloat(rgbArray[3]),
        };
    }
    throw new Error(`Invalid RGBA string: ${rgbaStringInput}`);
};
